module.exports = __webpack_public_path__ + "assets/paragraph-spacing.b2469760.svg";